import React, { useEffect, useState } from "react";
import styled from "styled-components";

const PostBody = (content) => {
  const [lineCut, setLineCut] = useState(false);
  useEffect(() => {
    var el = document.getElementById("post_content");
    var divHeight = el.offsetHeight;
    var lineHeight = parseInt(el.style.lineHeight);
    var lines = divHeight / lineHeight;
    // alert("Lines: " + lines);
    console.log(lines);
    if (lines >= 3) {
      setLineCut(true);
      console.log(false);
    } else {
      setLineCut(false);
      console.log(true);
    }
  });
  return (
    <div className="mt-2 ">
      <p className="text-sm md:text-base text-gray-400  ">
        <PostLine id="post_content" style={{ lineHeight: "20px" }}>
          {" "}
          In publishing and graphic design, Lorem ipsum is a placeholder text
          commonly used to demonstrate the visual form of a document or a
          typeface without relying on meaningful content. Lorem ipsum may be
          used as a placeholder before final copy is available.{" "}
        </PostLine>
        <span className="cursor-pointer text-gray-300 font-semibold">
          {lineCut ? "Read more" : ""}
        </span>
      </p>{" "}
    </div>
  );
};

export default PostBody;

const PostLine = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 3;

  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
